module.exports = __webpack_public_path__ + "img/solar_add-square-broken.5114b8be.svg";